export default __webpack_public_path__ + "static/media/pt.a93e7ea8.svg";